import React from 'react'
import DataView from 'EurestoComponents/DataForm'
import Constants from 'EurestoFonction/Constants'

export default () => (
    <DataView module={Constants.module.SDD} object={Constants.donnee.classeur}/>
)



// WEBPACK FOOTER //
// ./app/App/Module/Configuration/Component/SuiviDossier/Classeur/index.js